// src/pages/Weeklydeskplanner/index.jsx
import React, { useEffect, useState } from "react";
import CollectionPage from "./Collectionpage";
import { getWeeklyDeskPlanners, PRODUCTS_PER_PAGE } from "../data/weeklyDeskPlanners";

export default function Weeklydeskplanner() {
  const [products, setProducts] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    getWeeklyDeskPlanners()
      .then(setProducts)
      .catch(err => setError(err.message || "Failed to load products"));
  }, []);

  if (error) {
    return <div className="min-h-screen flex items-center justify-center text-red-600">{error}</div>;
  }
  if (!products) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Loading...</div>;
  }

  const config = {
    products,
    productsPerPage: PRODUCTS_PER_PAGE,
    basePath: "/weekly-desk-planner",
    announcement: {
      headline: "Plan your week in style — new designs are here!",
      subtext: "300+ designs to personalise • No code required",
    },
    hero: {
      title: "Weekly Desk Planners",
      subtitle: "Your full week, beautifully laid out",
     featuredIn: ["PREMIUM QUALITY", "TRUSTED CRAFTSMANSHIP", "PAN INDIA DELIVERY"],
      quote: "Finally a desk planner that actually looks good on my desk — and keeps me on track all week.",
      quoteLink: "#",
      rating: "4.7",
      ratingCount: "1000+",
    },
  };

  return <CollectionPage config={config} />;
}